// src/components/Register.jsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { toast } from 'react-toastify';

export default function Register({ onRegistered }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    fsra_license: '',
    companyName: '',
    companyWebsite: ''
  });
  const [registering, setRegistering] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('📨 Submit pressed. Form:', JSON.stringify(form, null, 2));
    setRegistering(true);

    try {
      const res = await api.post('/agent/register', form);
      console.log('🚀 Full Response:', res); // debug
      console.log('✅ API Response Data:', res.data);

      const token = res.data?.token;
      const agent = res.data?.agent;

      console.log('🪪 Extracted token:', token);
      console.log('👤 Extracted agent:', agent);

      if (token) {
        localStorage.setItem('token', token);
        console.log('💾 Token saved to localStorage');
      }

      if (token && agent) {
        toast.success('🎉 Registration successful!');
        setSuccess(true);
        onRegistered(agent);
        navigate('/dashboard');
      } else {
        toast.error('⚠️ Unexpected response from server.');
        console.warn('❓ Unexpected structure:', res.data);
      }

    } catch (error) {
      const msg = error?.response?.data?.message || 'Registration failed.';
      console.error('❌ Backend error:', msg);
      toast.error(msg);
    } finally {
      setRegistering(false);
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center' }}>📝 Create Your Account</h2>

      <form onSubmit={handleSubmit} style={{ marginTop: 20 }}>
        <input
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="fsra_license"
          placeholder="FSRA License #"
          value={form.fsra_license}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="companyName"
          placeholder="Company Name"
          value={form.companyName}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="companyWebsite"
          placeholder="Company Website"
          value={form.companyWebsite}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <button type="submit" disabled={registering} style={buttonStyle}>
          {registering ? 'Registering…' : 'Register'}
        </button>

        {success && (
          <p style={{ color: 'green', marginTop: 12 }}>
            ✅ Successfully Registered! Redirecting...
          </p>
        )}
      </form>

      <div style={linkRowStyle}>
        <Link to="/login" style={linkStyle}>
          Already have an account? Login
        </Link>
      </div>
    </div>
  );
}

// Styles
const containerStyle = {
  maxWidth: 400,
  margin: '60px auto',
  padding: 20,
  border: '1px solid #ddd',
  borderRadius: 10,
  backgroundColor: '#fff',
  boxShadow: '0px 4px 20px rgba(0,0,0,0.05)'
};

const inputStyle = {
  display: 'block',
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  borderRadius: 6,
  border: '1px solid #ccc',
  marginTop: 12
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#2C3E91',
  color: 'white',
  border: 'none',
  borderRadius: 6,
  fontSize: 16,
  cursor: 'pointer',
  marginTop: 16
};

const linkRowStyle = {
  marginTop: 20,
  textAlign: 'center'
};

const linkStyle = {
  color: '#2C3E91',
  textDecoration: 'none',
  fontSize: 14
};